export { LANGUAGE_MAPPINGS, SUPPORTED_LOCALES } from './localeMapping'
export type { LocaleMapping } from './localeMapping'
